import { getBaseUrl } from '@/xhr/connections';

import twitterOAuth1Service from './oauth1';
// WARNING: Twitter OAuth2 is in Beta, user can login but can not upload media (images|video) with this API version
import twitterOAuth2Service from './oauth2';

export const API_TWITTER_OAUTH1_ENDPOINT = getBaseUrl() + '/api/v1/twitter/oauth1';
export const API_TWITTER_OAUTH2_ENDPOINT = getBaseUrl() + '/api/v1/twitter/oauth2';

const api = {
  twitter: twitterOAuth1Service,
  twitterV2: twitterOAuth2Service,
};
export { twitterOAuth1Service, twitterOAuth2Service };
export default api;
